class AddonItems extends HTMLElement {
    constructor() {
        super();
        this.container = this.querySelector('ul');
        this.groupId = this.getAttribute('group-id');
        this.items = this.querySelectorAll('addon-item');

        if (this.items.length) {
            this.items.forEach((item) => {
                item.addEventListener('addon:select', (e) => {
                    this.toggle(item);
                });
            });
        }

        document.addEventListener('product-ajax:added', (e) => this.remove());
        document.addEventListener(`addon:${this.groupId}:remove-addon`, (e) => this.remove());
    }

    remove() {
        this.removeAttribute('selected');
        this.items.forEach((item) => {
            if (item.getAttribute('selected')) {
                item.removeAttribute('selected');
            }
            if (this.groupId === 'side-unit') {
                item.setAttribute('quantity', '1');
                const select = item.querySelector('[data-addon-quantity]');
                if (select) select.value = '1';
            }
        });

        document.dispatchEvent(new CustomEvent('addon:removed', {
            detail: {
                id: this.groupId,
            }
        }));
    }

    toggle(item) {
        if (item.hasAttribute('selected')) {
            item.removeAttribute('selected');
            this.removeAttribute('selected');
            if (this.groupId === 'side-unit') {
                item.setAttribute('quantity', '1');
                const select = item.querySelector('[data-addon-quantity]');
                if (select) select.value = '1';
            }

            document.dispatchEvent(new CustomEvent('addon:removed', {
                detail: {
                    id: this.groupId,
                }
            }));

            return;
        }

        this.setAttribute('selected', item.getAttribute('key'));
        this.items.forEach((addon) => {
            if (addon.getAttribute('key') === item.getAttribute('key')) {
                addon.setAttribute('selected', 'selected');
            } else {
                addon.removeAttribute('selected');
            }
        });

        document.dispatchEvent(new CustomEvent('addon:selected', {
            detail: {
                id: this.groupId,
                product: {
                    title: item.getAttribute('product-title'),
                    key: item.getAttribute('key')
                }
            }
        }));
    }

    static get observedAttributes() {
        return [...super.observedAttributes, 'selected']
    }
}

class AddonItem extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.querySelector('button').addEventListener('click', (e) => this.handleClick());

        // Only side units can be ordered as a pair; all other add-ons remain single items.
        if (this.getAttribute('addon-group-id') === 'side-unit' && !this.querySelector('[data-addon-quantity]')) {
            const details = this.querySelector('.addon-card__details');
            if (!details) return;

            const label = document.createElement('label');
            label.className = 'addon-card__quantity';
            label.style.cssText = 'display:flex;align-items:center;gap:0.5rem;margin-top:0.5rem;';
            label.textContent = 'Number of side units';

            const select = document.createElement('select');
            select.setAttribute('data-addon-quantity', '');
            select.setAttribute('aria-label', 'Number of side units');
            select.style.cssText = 'min-width:3.5rem;padding:0.25rem;border:1px solid currentColor;border-radius:4px;background:transparent;';
            [1, 2].forEach((quantity) => {
                const option = document.createElement('option');
                option.value = String(quantity);
                option.textContent = String(quantity);
                select.appendChild(option);
            });
            select.value = this.getAttribute('quantity') === '2' ? '2' : '1';
            this.setAttribute('quantity', select.value);
            select.addEventListener('change', () => {
                this.setAttribute('quantity', select.value);
                if (this.hasAttribute('selected')) {
                    document.dispatchEvent(new CustomEvent('addon:selected', {
                        detail: { id: 'side-unit', product: {
                            title: this.getAttribute('product-title'), key: this.getAttribute('key')
                        } }
                    }));
                }
            });
            label.appendChild(select);
            details.appendChild(label);
        }
    }

    render() {
    }

    handleClick() {
        this.dispatchEvent(
            new CustomEvent('addon:select')
        );
    }

    static get observedAttributes() {
        return [...super.observedAttributes, 'selected']
    }
}

if (!customElements.get('addon-items')) {
    customElements.define(
        'addon-items',
        AddonItems
    );
}

if (!customElements.get('addon-item')) {
    customElements.define(
        'addon-item',
        AddonItem
    );
}

class AddonsButton extends HTMLElement {
    constructor() {
        super();
        this.button = this.querySelector('button');
        this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
        if (this.button) {
            this.button.addEventListener('click',this.handleClick);
        }
    }

    handleClick() {
        if (this.addonsDrawer && typeof this.addonsDrawer.show === 'function') {
            this.addonsDrawer.show();
        }
    }

    get addonId() {
        return this.getAttribute('addon-id');
    }

    get addonsDrawer() {
        return document.querySelector(`#AddonsDrawer-${this.addonId}`);
    }

    disconnectedCallback() {
        this.button.removeEventListener('click', this.handleClick);
    }
}

class AddonsDrawer extends DrawerComponent {
    constructor() {
        super();
        window.FoxKitSections = FoxTheme.utils.getSectionId(this);
    }

    get requiresBodyAppended() {
        return false;
    }

    get sectionId() {
        return this.getAttribute('data-section-id');
    }
}

if (!customElements.get('addons-drawer')) {
    customElements.define(
        'addons-drawer',
        AddonsDrawer
    );
}

if (!customElements.get('addons-button')) {
    customElements.define(
        'addons-button',
        AddonsButton
    );
}

document.addEventListener('DOMContentLoaded', () => {
    const atcButton = document.querySelector('.product-form__submit');
    let pendingPostAddWizardStep = null;

    const moneyFormat = FoxTheme.settings.moneyFormat;
    const isTvGroup = (groupId) => groupId === 'tv' || groupId === '32-tv';
    const addonQuantity = (addon) => addon.getAttribute('addon-group-id') === 'side-unit'
        && addon.getAttribute('quantity') === '2' ? 2 : 1;

    // Shopify applies the actual bundle discount in the basket. These prices
    // let shoppers see that saving while choosing a matching-size mattress.
    const mattressDiscount = (addon) => {
        if (addon.getAttribute('addon-group-id') !== 'mattress') return 0;
        const productId = addon.getAttribute('product');
        if (productId === '7080880668857' || productId === '7469827326137') return 55;
        const title = addon.getAttribute('product-title') || '';
        if (/^Nest\b/i.test(title)) return 15;
        if (/^(Sealy|Silentnight)\b/i.test(title)) return 10;
        return 0;
    };

    const addonPrice = (addon) => {
        const price = Number.parseInt(addon.getAttribute('price'), 10) || 0;
        if (isTvGroup(addon.getAttribute('addon-group-id'))) {
            return Math.max(0, price - 5000);
        }
        return Math.round(price * (100 - mattressDiscount(addon)) / 100);
    };

    const updateMattressCards = () => {
        document.querySelectorAll('addon-item[addon-group-id="mattress"]').forEach((addon) => {
            const discount = mattressDiscount(addon);
            const priceElement = addon.querySelector('.addon-card__price');
            if (!priceElement || !discount) return;

            const originalPrice = Number.parseInt(addon.getAttribute('price'), 10) || 0;
            priceElement.textContent = FoxTheme.Currency.formatMoney(addonPrice(addon), moneyFormat);
            let original = addon.querySelector('[data-mattress-bundle-original]');
            if (!original) {
                original = document.createElement('s');
                original.setAttribute('data-mattress-bundle-original', '');
                priceElement.insertAdjacentElement('afterend', original);
            }
            original.textContent = FoxTheme.Currency.formatMoney(originalPrice, moneyFormat);

            let label = addon.querySelector('[data-mattress-bundle-label]');
            if (!label) {
                label = document.createElement('p');
                label.setAttribute('data-mattress-bundle-label', '');
                original.insertAdjacentElement('afterend', label);
            }
            label.textContent = `${discount}% off with a TV bed`;
        });
    };

    const updateTvCards = () => {
        document.querySelectorAll('addon-item[addon-group-id="tv"], addon-item[addon-group-id="32-tv"]').forEach((addon) => {
            const priceElement = addon.querySelector('.addon-card__price');
            if (!priceElement) return;

            const originalPrice = Number.parseInt(addon.getAttribute('price'), 10) || 0;
            priceElement.textContent = FoxTheme.Currency.formatMoney(addonPrice(addon), moneyFormat);
            let original = addon.querySelector('[data-tv-bundle-original]');
            if (!original) {
                original = document.createElement('s');
                original.setAttribute('data-tv-bundle-original', '');
                original.style.cssText = 'margin-left:0.5rem;font-size:0.85em;opacity:0.7;';
                priceElement.insertAdjacentElement('afterend', original);
            }
            original.textContent = FoxTheme.Currency.formatMoney(originalPrice, moneyFormat);

            let label = addon.querySelector('[data-tv-bundle-label]');
            if (!label) {
                label = document.createElement('p');
                label.setAttribute('data-tv-bundle-label', '');
                label.style.cssText = 'margin:0.25rem 0;color:#287a3c;font-size:0.85em;font-weight:600;';
                original.insertAdjacentElement('afterend', label);
            }
            label.textContent = 'Save £50 with a TV bed';
        });
    };

    const updateButtonPrice = () => {
        if (atcButton !== null) {
            let price = Number.parseInt(atcButton.dataset.originalPrice);
            const addons = document.querySelectorAll('addon-item[selected]');
            if (addons.length) {
                for (let i = 0; i < addons.length; i++) {
                    price += addonPrice(addons[i]) * addonQuantity(addons[i]);
                }
            }

            const totalSpan = atcButton.querySelector('#productTotal');
            if (totalSpan) {
                totalSpan.textContent = FoxTheme.Currency.formatMoney(price, moneyFormat);
            }
        }
    };

    const updateWizardTotal = () => {
        const totals = document.querySelectorAll('.addons-wizard-step__total-value');
        if (totals.length) {
            for (let i = 0; i < totals.length; i++) {
                let price = Number.parseInt(totals[i].dataset.originalPrice);
                const addons = document.querySelectorAll('addon-item[selected]');
                if (addons.length) {
                    for (let j = 0; j < addons.length; j++) {
                        price += addonPrice(addons[j]) * addonQuantity(addons[j]);
                    }
                }
                totals[i].textContent = FoxTheme.Currency.formatMoney(price, moneyFormat);
            }
        }
    };

    const updateSummary = () => {
        const templateEl = document.querySelector('template[data-wizard-step-summary-item-template]');
        const summaryRoots = document.querySelectorAll('[data-wizard-step-summary-content]');

        if (!templateEl || !summaryRoots.length) {
            return;
        }

        summaryRoots.forEach((content) => {
            const slots = content.querySelectorAll('[data-wizard-step-summary-addon-slot]');

            slots.forEach((slot) => {
                const groupId = slot.getAttribute('data-wizard-step-summary-item');
                const groupLabel = slot.getAttribute('data-wizard-step-summary-item-title') || '';

                slot.replaceChildren();

                if (!groupId) {
                    return;
                }

                const selectedAddon = [...document.querySelectorAll('addon-item[selected]')].find(
                    (el) => el.getAttribute('addon-group-id') === groupId
                );

                if (!selectedAddon) {
                    return;
                }

                const productTitle = selectedAddon.getAttribute('product-title') || '';
                const fragment = templateEl.content.cloneNode(true);
                const typeEl = fragment.querySelector('[data-wizard-step-summary-item-type]');
                const titleEl = fragment.querySelector('[data-wizard-step-summary-item-title]');

                if (typeEl) {
                    typeEl.textContent = groupLabel;
                }
                if (titleEl) {
                    titleEl.textContent = groupId === 'side-unit'
                        ? `${addonQuantity(selectedAddon)} × ${productTitle}`
                        : groupId === 'mattress' && mattressDiscount(selectedAddon)
                            ? `${productTitle} (${mattressDiscount(selectedAddon)}% bundle saving)`
                            : isTvGroup(groupId)
                                ? `${productTitle} (£50 bundle saving)`
                            : productTitle;
                }

                slot.append(...fragment.children);
            });
        });
    };

    const updateReview = () => {
        const root = document.querySelector('#addon-drawers');
        if (!root) {
            return;
        }

        const slots = root.querySelectorAll('[data-wizard-review-slot]');

        slots.forEach((slot) => {
            const groupId = slot.getAttribute('data-addon-group-id');
            const emptyLabel = slot.getAttribute('data-wizard-review-empty-label') || 'Not selected';

            slot.replaceChildren();

            if (!groupId) {
                return;
            }

            const selectedAddon = [...root.querySelectorAll('addon-item[selected]')].find(
                (el) => el.getAttribute('addon-group-id') === groupId
            );

            if (!selectedAddon) {
                const empty = document.createElement('p');
                empty.className = 'addons-wizard-review__empty';
                empty.textContent = emptyLabel;
                slot.appendChild(empty);
                return;
            }

            const source = selectedAddon.querySelector('.addon-card__content');
            if (!source) {
                const empty = document.createElement('p');
                empty.className = 'addons-wizard-review__empty';
                empty.textContent = emptyLabel;
                slot.appendChild(empty);
                return;
            }

            const wrap = document.createElement('div');
            wrap.className = 'addon-card addons-wizard-review__addon';
            const content = source.cloneNode(true);
            content.querySelector('.addon-card__quantity')?.remove();
            const title = content.querySelector('.addon-card__title');
            const price = content.querySelector('.addon-card__price');
            const quantity = addonQuantity(selectedAddon);
            if (title && groupId === 'side-unit') {
                title.textContent = `${quantity} × ${selectedAddon.getAttribute('product-title') || ''}`;
            }
            if (price && groupId === 'side-unit') price.textContent = FoxTheme.Currency.formatMoney(
                Number.parseInt(selectedAddon.getAttribute('price'), 10) * quantity, moneyFormat
            );
            wrap.appendChild(content);
            slot.appendChild(wrap);
        });
    };

    const updateMattressChooser = () => {
        document.querySelectorAll('#addon-drawers addon-items[group-id="mattress"]').forEach((group) => {
            const items = [...group.querySelectorAll('addon-item')];
            if (items.length < 2) return;

            let controls = group.querySelector('[data-mattress-chooser]');
            if (!controls) {
                controls = document.createElement('div');
                controls.setAttribute('data-mattress-chooser', '');
                controls.className = 'mattress-chooser';
                controls.innerHTML = `
                    <p class="mattress-chooser__heading">Find your mattress</p>
                    <div class="mattress-chooser__fields">
                        <label class="mattress-chooser__field">Brand
                            <select data-mattress-brand>
                                <option value="all">All brands</option>
                                <option value="nest">Nest</option>
                                <option value="sealy">Sealy</option>
                                <option value="silentnight">Silentnight</option>
                            </select>
                        </label>
                        <label class="mattress-chooser__field">Bundle price
                            <select data-mattress-budget>
                                <option value="0">Any price</option>
                                <option value="40000">Up to £400</option>
                                <option value="60000">Up to £600</option>
                                <option value="80000">Up to £800</option>
                                <option value="100000">Up to £1,000</option>
                            </select>
                        </label>
                    </div>
                    <p class="mattress-chooser__count" data-mattress-count role="status" aria-live="polite"></p>
                    <button type="button" class="mattress-chooser__toggle" data-mattress-show-all></button>
                    <p class="mattress-chooser__empty" data-mattress-empty hidden>No mattresses match. Try another price or brand.</p>`;
                group.insertBefore(controls, group.querySelector('ul'));
                controls.dataset.mode = 'featured';
                controls.querySelector('[data-mattress-brand]').addEventListener('change', () => {
                    controls.dataset.mode = 'all';
                    updateMattressChooser();
                });
                controls.querySelector('[data-mattress-budget]').addEventListener('change', () => {
                    controls.dataset.mode = 'all';
                    updateMattressChooser();
                });
                controls.querySelector('[data-mattress-show-all]').addEventListener('click', () => {
                    controls.dataset.mode = controls.dataset.mode === 'featured' ? 'all' : 'featured';
                    controls.querySelector('[data-mattress-brand]').value = 'all';
                    controls.querySelector('[data-mattress-budget]').value = '0';
                    updateMattressChooser();
                });
            }

            const cheapest = (matches) => matches.sort((a, b) => addonPrice(a) - addonPrice(b))[0];
            const featured = new Set([
                ...items.filter((item) => ['7080880668857', '7469827326137'].includes(item.getAttribute('product'))),
                cheapest(items.filter((item) => /^Nest\b/i.test(item.getAttribute('product-title') || '') && mattressDiscount(item) !== 55)),
                cheapest(items.filter((item) => /^(Sealy|Silentnight)\b/i.test(item.getAttribute('product-title') || '')))
            ].filter(Boolean));
            const brand = controls.querySelector('[data-mattress-brand]').value;
            const budget = Number(controls.querySelector('[data-mattress-budget]').value);
            const showAll = controls.dataset.mode === 'all';
            let visible = 0;
            items.forEach((item) => {
                const title = item.getAttribute('product-title') || '';
                const matches = (showAll || featured.has(item))
                    && (brand === 'all' || title.toLowerCase().startsWith(brand))
                    && (!budget || addonPrice(item) <= budget);
                const show = matches || item.hasAttribute('selected');
                item.hidden = !show;
                if (show) visible++;
            });
            controls.querySelector('[data-mattress-count]').textContent = showAll
                ? `Showing ${visible} of ${items.length} mattresses`
                : 'Featured bundle offers';
            controls.querySelector('[data-mattress-show-all]').textContent = showAll
                ? 'Show featured offers'
                : `View all ${items.length} mattresses`;
            controls.querySelector('[data-mattress-empty]').hidden = visible !== 0;
        });
    };

    const syncWizardUi = () => {
        updateMattressCards();
        updateTvCards();
        updateMattressChooser();
        updateButtonPrice();
        updateWizardTotal();
        updateSummary();
        updateReview();
    };

    const clearAllAddonSelectionsInAddonDrawers = () => {
        const root = document.querySelector('#addon-drawers');
        if (!root) {
            return;
        }

        const groupsToNotify = [];

        root.querySelectorAll('addon-items').forEach((group) => {
            const groupId = group.getAttribute('group-id');
            const hadSelected = Boolean(group.querySelector('addon-item[selected]'));

            group.removeAttribute('selected');
            group.querySelectorAll('addon-item[selected]').forEach((item) => {
                item.removeAttribute('selected');
            });
            if (groupId === 'side-unit') {
                group.querySelectorAll('addon-item').forEach((item) => {
                    item.setAttribute('quantity', '1');
                    const select = item.querySelector('[data-addon-quantity]');
                    if (select) select.value = '1';
                });
            }

            if (groupId && hadSelected) {
                groupsToNotify.push(groupId);
            }
        });

        if (groupsToNotify.length) {
            groupsToNotify.forEach((groupId) => {
                document.dispatchEvent(new CustomEvent('addon:removed', {
                    detail: {
                        id: groupId,
                    },
                }));
            });
        } else {
            syncWizardUi();
        }
    };

    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
        if (atcButton !== null) {
            atcButton.dataset.originalPrice = event.data.variant.price;
        }
        document.querySelectorAll('addons-drawer').forEach((drawer) => {
            drawer.dataset.bedPriceCents = event.data.variant.price;
        });
        document.dispatchEvent(new Event('bed:price-change'));
        const url = `${event.data.productUrl}?variant=${event.data.variant.id}&view=addons`

        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                updateAddons(html)
            })
    });

    const updateAddons = (html) => {
        const drawerRoot = document.querySelector('#addon-drawers');
        const drawerSource = html.querySelector('#addon-drawers');

        if (drawerRoot && drawerSource) {
            drawerRoot.innerHTML = drawerSource.innerHTML;
        }

        syncWizardUi();
    };

    document.addEventListener('addon:selected', () => {
        syncWizardUi();
    });

    document.addEventListener('addon:removed', () => {
        syncWizardUi();
    });

    document.addEventListener('product-ajax:added', () => {
        syncWizardUi();

        if (pendingPostAddWizardStep) {
            const { wizard, stepIndex } = pendingPostAddWizardStep;
            pendingPostAddWizardStep = null;

            if (wizard && typeof wizard.goToStep === 'function') {
                wizard.goToStep(stepIndex);
            }
        }
    });

    document.addEventListener('product-ajax:error', () => {
        pendingPostAddWizardStep = null;
    });

    document.addEventListener('click', (event) => {
        const reviewAtc = event.target.closest('[data-addons-wizard-review-atc]');
        if (!reviewAtc) {
            return;
        }

        const drawer = reviewAtc.closest('addons-drawer');
        const wizard = drawer ? drawer.querySelector('wizard-component') : null;
        const postAddStepAttr = drawer ? drawer.getAttribute('data-addons-wizard-post-add-step') : null;
        const mainSubmit = document.querySelector('form[is="product-form"] .product-form__submit');

        if (!mainSubmit || !wizard || !postAddStepAttr) {
            return;
        }

        const stepIndex = parseInt(postAddStepAttr, 10);
        if (Number.isNaN(stepIndex)) {
            return;
        }

        const productForm = mainSubmit.closest('form[is="product-form"]');
        if (productForm) {
            productForm.setAttribute('data-suppress-cart-drawer', 'true');
        }

        pendingPostAddWizardStep = { wizard, stepIndex };
        mainSubmit.click();
    });

    document.addEventListener('click', (event) => {
        const viewCartButton = event.target.closest('[data-addons-wizard-view-cart]');
        if (viewCartButton) {
            const addonsDrawer = viewCartButton.closest('addons-drawer');
            const cartDrawer = document.querySelector('cart-drawer');

            event.preventDefault();

            const hideAddonsDrawer = addonsDrawer?.open ? addonsDrawer.hide() : Promise.resolve();

            hideAddonsDrawer.then(() => {
                if (cartDrawer && typeof cartDrawer.show === 'function') {
                    cartDrawer.show(viewCartButton);
                }
            });
            return;
        }

        const startOver = event.target.closest('.addons-wizard-start-over-button');
        if (!startOver || !document.querySelector('#addon-drawers')?.contains(startOver)) {
            return;
        }

        clearAllAddonSelectionsInAddonDrawers();
    }, true);

    syncWizardUi();
});
